var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#e35f14;stroke-miterlimit:10;}.cls-2{fill:#e35f14;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.16,17H5a1.93,1.93,0,0,1-2-1.86V7A1.93,1.93,0,0,1,5,5.16H20.16a1.93,1.93,0,0,1,2,1.86v8.14A1.93,1.93,0,0,1,20.16,17Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M15.35,11.59l-5.06,2.89a.52.52,0,0,1-.71-.16h0a.62.62,0,0,1-.07-.19,2.11,2.11,0,0,1,0-.26V8.23c0-.34.16-.58.44-.61a.65.65,0,0,1,.36.07l5.08,2.89A.55.55,0,0,1,15.35,11.59Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContent);
export default __webpack_public_path__ + "static/media/content.760987d4b08c115fb991e69d058cb1a2.svg";
export { ForwardRef as ReactComponent };